module.exports = __webpack_public_path__ + "static/img/logo.20e18fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/logo.png
// module id = QQ3S
// module chunks = 81